module.exports = __webpack_public_path__ + "img/zip.151bdfc2.svg";